export default {
  data() {
    return {
      searchMarkerPosition: {
        lat: null,
        lng: null
      },
      justFocusOnSearch: false,
      searchTimer: null
    }
  },

  methods: {
    onSearchSuggestion(latLng) {
      if (!this.justFocusOnSearch) {
        this.searchMarkerPosition = latLng
      }
    }
  },

  watch: {
    searchMarkerPosition: function (newVal) {
      this.$emit('input', newVal)

      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }

      this.searchTimer = setTimeout(() => {
        if (this.$refs.modalmap?.mapObject) {
          this.$refs.modalmap.mapObject.flyTo([newVal?.lat, newVal?.lng], 16)
        }
      }, 100)
    }
  },

  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  }
}